// extracted by mini-css-extract-plugin
export default {"titleContainer":"sgj798","issueContainer":"kan9BG","issuesContainer":"ZDCeld","issueLocation":"s28DJI","explanationContainer":"FYARv8"};